import { Input, type InputProps } from "@chakra-ui/react";
import { useState } from "react";

export const parseWholeNumber = (text: string): number | null => {
  const trimmed = text.trim();
  if (trimmed === "") return null;
  return /^\d+$/.test(trimmed) ? Number(trimmed) : Number.NaN;
};

export interface WholeNumberInputProps extends Omit<InputProps, "type" | "value" | "onChange" | "defaultValue"> {
  numericValue: number | null;
  onNumericChange: (value: number | null) => void;
}

export const WholeNumberInput = ({ numericValue, onNumericChange, ...rest }: WholeNumberInputProps) => {
  const [text, setText] = useState(numericValue == null || Number.isNaN(numericValue) ? "" : String(numericValue));
  const shown = Object.is(parseWholeNumber(text), numericValue) ? text : (numericValue ?? "").toString();

  return (
    <Input
      value={shown}
      onChange={(e) => {
        setText(e.target.value);
        onNumericChange(parseWholeNumber(e.target.value));
      }}
      autoComplete="off"
      inputMode="numeric"
      rounded="md"
      {...rest}
    />
  );
};
